export enum SerologyShipMethod {    
    ShipToCenter = 1,
    ShipToRemoteDonor = 2,
    ShipToPhlebot = 3
}